import { Component,ElementRef,NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from "app/shared/services/api.service";
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { MapsAPILoader } from '@agm/core';
@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss',
  '../../../../../../assets/sass/pages/page-users.scss',
  '../../../../../../assets/sass/libs/select.scss'],
  encapsulation: ViewEncapsulation.None

})
export class UserEditComponent implements OnInit {
  @ViewChild('fileInput') myInputVariable: ElementRef;
  @ViewChild("search")
  public searchElementRef: ElementRef;
  selectedValue:string[]=[];
  formData=new FormData();
  userId:any;
  selectValue='';
  studentData:any;
  address: string;
   latitude: number;
   longitude: number;
   zoom: number;
  private geoCoder;
  
  userData={
    name:'',
    email	:'', 
    phone	:'',
    roles	:'',
    linkedIn:'',
    dob:'',
    sex:'',
    address:'',
    location:'',
    notes:'',
    admin_notes:'',
    lat:'',
    lng:'',
    password:'',
    image:''
  };
// ----- Student Fields ----
  studentsData={
    name:'',
    email	:'', 
    phone	:'',
    dob:'',
    gender:'',
    bio: '',
    badges: [{_id:''}],
    goal: '',
    course_id:'',
    mode: '',
    hunting_by: '',
    farming_by: '',
    team: '',
    project_ids: '',
    placementinfo: '',
    overview: '',
    college_id: '',
    last_qualification:'', 
    admin_notes:'',
    notes:'',
    address:'',
    
  }
  // ------ End ---------------
  fileData:File;
  roles=[];
  imgUrl:any;
  courseList = []
  selectedCourse = null;
  selectedFarmingBy = null;
  selectedHuntingBy=null;
  selectedBatch:string[]=[];
  isPassword:boolean=false
  imageUrl=environment.apiUrls.imageUrl;
  currentUrl:any
  studentId:any
  collegeList=[];
  selectedCollege=null
  usersList = [];
  teamId = '631ad9b6ce5c666542591be9'
  goalId = '631ad878ce5c666542591bd4'
  learningModeId='631ad8abce5c666542591bd9'
  badgeId= '631ada06ce5c666542591bf2'
  selectBadge:string[]=[]
  badgeList=[];
  selectGoal:string[]=[]
  selectedTeam=null;
  goalList = [];
  teamList = [];
  learningList =[];
  selectLearningMode=null
  storeData:any
  constructor(private apiService:ApiService,
    public toastr: ToastrService,
              private route:Router,
              private mapsAPILoader: MapsAPILoader,
               private ngZone: NgZone,
              private activatedroute:ActivatedRoute) { 
                this.currentUrl=this.activatedroute.snapshot.routeConfig.path
                this.storeData=JSON.parse(localStorage.getItem('user'))
              }

  ngOnInit(): void {

    if(this.currentUrl == 'users-edit/:id'){
      this.activatedroute.paramMap.subscribe(params => { 
        this.userId = params.get('id'); 
      });
    this.getUserById();
  }
  if(this.currentUrl == 'student-edit/:id'){
    this.activatedroute.paramMap.subscribe(params => { 
      this.studentId = params.get('id'); 
    });
    this.getStudentById()
    this.getAllCollege()
   this.getGoalTagByCategory()
   this.getUsers()
   this.getTeamTagByCategory()
   this.getModeTagByCategory()
   this.getBadegeTagByCategory()
   this.getCourseList()
   this.locationAutoComplete()
  }
  // this.getBatchList()
}

 
  getCourseList() {
    this.apiService.getCourseList(1, 100).subscribe((res: any) => {
      this.courseList = res.data.items
    })
  }
  getCourseId(event: any) {
    this.selectedCourse
    
  }
  getAllCollege(){
    this.apiService.getBusinessList(1,100).subscribe((res:any)=>{
      this.collegeList=res.data.items
    })
  }
  getCollegeId(event:any){
    this.selectedCollege
  }
  
  getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList=res.items
      this.usersList = res.items.filter(user => user.roles == "employee")
    })
  }
  getHuntId(event: any) {
    this.selectedHuntingBy
  }
  getFarmId(event:any){
    this.selectedFarmingBy
  }
  getGoalTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.goalId).subscribe((res: any) => {
      this.goalList = res.data
    })
  }
  getGoalId(event:any){
    this.selectGoal
  }
  getTeamTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
      this.teamList = res.data
    })
  }
  getTeamId(event:any){
    this.selectedTeam
  }
  getModeTagByCategory(){
    this.apiService.getTagByTagCatgoryId(this.learningModeId).subscribe((res:any)=>{
      this.learningList=res.data
    })
  }
  getModeId(event:any){
    this.selectLearningMode
  }
  getBadegeTagByCategory() {
    this.apiService.getTagByTagCatgoryId(this.badgeId).subscribe((res: any) => {
      this.badgeList = res.data
    })
  }
  getBadgeId(event:any){
    this.selectBadge
  }
  getStudentById(){
    this.apiService.getStudentById(this.studentId).subscribe((res:any)=>{

      this.studentsData = res?.data
      if(res?.data?.college?._id){
        this.selectedCollege = res?.data?.college?._id
      }
      if(res?.data?.hunting_by?._id){
        this.selectedHuntingBy = res?.data?.hunting_by?._id
      }
      if(res?.data?.farming_by?._id){
        this.selectedFarmingBy = res?.data?.farming_by?._id
      }
      if(res?.data?.team){
        this.selectedTeam = res?.data?.team._id
      }
      if(res?.data?.course?._id){
        this.selectedCourse = res?.data?.course?._id
      }
      if(this.studentsData.badges){
        for(let item of this.studentsData.badges){
          this.selectBadge.push(item._id)
       }
       this.selectBadge = this.selectBadge.map((item)=>item)
      }
      
      })

}
  
  getUserById(){
    this.apiService.getUserbyId(this.userId).subscribe((res:any)=>{
      this.userData=res.data
    })
  }

  getRoles(){
    this.apiService.getRoles().subscribe((res:any)=>{
      this.roles=res.data
    })
  }
  
userUpdate(){  
    if(this.userId){
      
    this.formData.append('name',this.userData.name),
    this.formData.append('email',this.userData.email)
    this.formData.append('phone',this.userData.phone),
    this.formData.append('roles',this.userData.roles),
    this.formData.append('notes',this.userData.notes),
    this.formData.append('admin_notes',this.userData.admin_notes),
    this.formData.append('lat',JSON.stringify(this.latitude)),
    this.formData.append('lng',JSON.stringify(this.longitude)),
    this.formData.append('linkedIn',this.userData.linkedIn),
    this.formData.append('dob',this.userData.dob),
    this.formData.append('sex',this.selectValue),

    // this.formData.append('course',this.selectedValue),
    this.formData.append('password',this.userData.password),
    this.formData.append('image',this.fileData),
    this.apiService.updateUser(this.userId,this.formData).subscribe((res:any)=>{
      if(res.statusCode === 200){
      console.log('update res',res)
      this.toastr.success('Updated successfully',res.message) 
      this.route.navigate(['/allUsers-list'])
      }
      else{this.toastr.error(res.error)}
    })
  
  }
 
}
studentUpdate(){
    if(this.studentId){  

      let body={
        name: this.studentsData.name,
        email	:this.studentsData.email, 
        phone	:this.studentsData.phone,
        dob:this.studentsData.dob,
        sex:this.selectValue,
        bio: this.studentsData.bio,
        badges: this.selectBadge,
        // goal: this.selectGoal,
        // mode:this.selectLearningMode,
        hunting_by: this.selectedHuntingBy,
        farming_by: this.selectedFarmingBy,
        team: this.selectedTeam,
        project_ids: this.studentsData.project_ids,
        placementinfo: this.studentsData.placementinfo,
        overview:this.studentsData.overview , 
        lat:this.longitude,
        lng:this.longitude, 
        address:this.address,
        course_id:this.selectedCourse,
        college_id: this.selectedCollege,
        last_qualification: this.studentsData.last_qualification, 
        admin_notes: this.studentsData.admin_notes,
        notes:this.studentsData.notes,
      }
  // this.imageUpload()
    this.apiService.updateStudent(this.studentId,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
      var student=res.data
      this.toastr.success(res.message) 
      // if(student?.user?.roles == 'student'){
        if(this.storeData.roles =='student'){
          this.route.navigate(['/profile'])
        }
      // }
      else if(this.storeData.roles =='admin') {
      this.route.navigate(['/students-list'])
      }
    }
      else{this.toastr.error(res.error)}
    })
  }
  else{
    alert('Something went Wrong!!!')
  }  
}
onSelectFile(event:any){
  if (event.target.files && event.target.files[0]) {
    var reader = new FileReader();
    this.fileData = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload=(event)=>{
      this.imgUrl=reader.result
    }
    this.imageUpload()
    
  }
}
imageUpload(){
  if(this.studentId){
    this.formData.append('image',this.fileData),
    this.apiService.uploadUserImage(this.studentId,this.formData).subscribe((res:any)=>{
    })
  } 
}
back(){
  this.route.navigate(['/allUsers-list'])    
}
backToStudent(){
  if(this.storeData.roles =='student'){
    this.route.navigate(['/profile'])
  }
  else if(this.storeData.roles =='admin') {
    this.route.navigate(['/students-list'])
    }   
}
resetImage(){
  this.imgUrl=''
  this.myInputVariable.nativeElement.value=null
  this.fileData=this.myInputVariable.nativeElement.files
}
setPassword(){
  this.isPassword =!this.isPassword
}
change(event): void{
  this.selectValue=event.target.value
 }

 locationAutoComplete() {
  this.mapsAPILoader.load().then(() => {
    this.geoCoder = new google.maps.Geocoder;

    let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef?.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();
        this.address = place.formatted_address;
        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        // set latitude, longitude and zoom
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
      });
    });
  });
}


}
